import DocumentTypeGrid from "presentation/components/DocumentType/DocumentTypeGrid";
import JobTitleGrid from "presentation/components/JobTitle/JobTitleGrid";
import NotificationGrid from "presentation/components/Notification/NotificationGrid";
import ParameterSetting from "presentation/components/Parameter/ParameterForm";
import EquipmentTemplatesTab from "presentation/components/Equipment/EquipmentTemplatesTab";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import React, { useRef } from "react";

const SettingPanel: React.FC = () => {
  const toast = useRef<Toast>(null);
  return (
    <div>
      <div className="card">
        <TabView>
          {/* <TabPanel header="Mapa de Horas" leftIcon="pi pi-calendar-clock mr-2">
            <TimesheetSetting />
          </TabPanel> */}
          <TabPanel header="Lista de Opções" leftIcon="pi pi-list mr-2">
            <ParameterSetting />
          </TabPanel>
          <TabPanel header="Funções e Cargos" leftIcon="pi pi-list mr-2">
            <JobTitleGrid />
          </TabPanel>
          <TabPanel header="Tipos de Documentos" leftIcon="pi pi-list mr-2">
            <DocumentTypeGrid />
          </TabPanel>
          {/* <TabPanel
            header="Tipos de Ausências"
            leftIcon="pi pi-list mr-2"
          ></TabPanel>
          <TabPanel
            header="Feriados e Compensações"
            leftIcon="pi pi-list mr-2"
          ></TabPanel> */}
          <TabPanel
            header="Equipamentos e Viaturas"
            leftIcon="pi pi-sliders-h mr-2"
          >
            <EquipmentTemplatesTab />
          </TabPanel>
          <TabPanel
            header="Emails e Notificações"
            leftIcon="pi pi-envelope mr-2"
          >
            <NotificationGrid />
          </TabPanel>
        </TabView>
        <div className="next-bottom"></div>
        <Toast ref={toast} position="bottom-right" />
      </div>
    </div>
  );
};

export default SettingPanel;
